import React, { memo } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Button } from '@beef/ui-kit';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const ContentActions = memo(({
  onConfirm, onAdditionalConfirm, data, isDisabledMainBtn = false, isDisabledAdditionalBtn = false,
}) => {
  const { buttonGroup } = data || {};
  return (
    <div className={cx('actions')}>
      <Button size="m" onClick={() => onConfirm(buttonGroup[0]?.href)} disabled={isDisabledMainBtn}>
        {buttonGroup?.[0]?.buttonText}
      </Button>
      {buttonGroup?.[1]?.buttonText && (
        <Button size="m" onClick={() => onAdditionalConfirm(buttonGroup[1]?.href)} variant="tertiary" disabled={isDisabledAdditionalBtn}>
          {buttonGroup[1].buttonText}
        </Button>
      )}

    </div>
  );
});

ContentActions.propTypes = {
  onConfirm: PropTypes.func,
  onAdditionalConfirm: PropTypes.func,
  data: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    imageUrl: PropTypes.string,
    buttonGroup: PropTypes.array,
  }),
  isDisabledMainBtn: PropTypes.bool,
  isDisabledAdditionalBtn: PropTypes.bool,
};

export { ContentActions };
